import React from "react";
import styled from "styled-components";
import { Tooltip } from "reactstrap";
import PropTypes from "prop-types";
import styleClass from "./DefaultMultipleSelect.module.scss";
import { MultiSelect } from "react-multi-select-component";
import { compareArrays } from "../../helpers/utils";

const DefaultMultipleSelect = ({
  options,
  onChange,
  plug,
  search,
  filtered_params,
  filtered_by,
  className,
  isLoading = false,
  defaultValue = [],
  hasSelectAll = true,
  customWidth,
  isDisabled = false,
}) => {
  const [data, setData] = React.useState(options || []);
  const [tooltip, setTooltip] = React.useState(false);
  const [selected, setSelected] = React.useState(defaultValue || []);
  const [update, setUpdate] = React.useState(false);

  React.useEffect(() => {
    if (options.join("") !== data.join("")){
      updateSelected();
    }
    if (update) {
      onChange(selected);
      setUpdate(!update);
    }
  }, [options, update]);

  const updateSelected = () => {
    setData(options);
    let optionsData = [];
    if (filtered_params !== undefined && filtered_by !== undefined) {
      if (Array.isArray(filtered_params[filtered_by])) {
        filtered_params[filtered_by].map(i => {
          let idx = options.findIndex(option => option.key == i);
          if (idx >= 0) {
            optionsData.push({
              label: options[idx].text,
              value: options[idx].key,
              checked: options[idx].checked,
              key: options[idx].key,
              index: idx,
            });
          }
        });
      } else if (
        !Array.isArray(filtered_params[filtered_by]) &&
        filtered_params[filtered_by] !== undefined
      ) {
        let idx = options.findIndex(
          option => option.key == filtered_params[filtered_by]
        );
        optionsData.push({
          label: options[idx].text,
          value: options[idx].key,
          checked: options[idx].checked,
          key: options[idx].key,
          index: idx,
        });
      } else if (typeof filtered_params == 'string' && filtered_params == 'all') {
        options.map((o, idx) => {
          optionsData.push({
            label: o.text,
            value: o.key,
            checked: o.checked,
            key: o.key,
            index: idx,
          });
        })
      } else if (Array.isArray(filtered_params) ) {
        if (!filtered_params.includes(filtered_by)) {
          options.map((o, idx) => {
            optionsData.push({
              label: o.text,
              value: o.key,
              checked: o.checked,
              key: o.key,
              index: idx,
            });
          })
        }
      }
    }
    setSelected(optionsData);
    setUpdate(!update);
  };

  const handleChangeCheckbox = e => {
    setSelected(e);
    setUpdate(!update);
  };

  const handleDeleteSelected = val => {
    const filteredOptions = selected.filter(item => item.value !== val);
    setSelected(filteredOptions);
    setUpdate(!update);
  };

  const customValueRenderer = (selected, _options) => {
    if (selected.length === 1) {
      return (
        <div className={styleClass.valueContainer}>
          <div className={styleClass.multiValue}>
            <div className={styleClass.multiValueLabel}>
              <span>{selected[0].label}</span>
            </div>
            <div
              className={styleClass.multiValueClear}
              onClick={() => handleDeleteSelected(selected[0].value)}
            >
              <svg
                height="14"
                width="14"
                viewBox="0 0 20 20"
                className={styleClass.icon}
              >
                <path d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"></path>
              </svg>
            </div>
          </div>
        </div>
      );
    } else if (_options?.length != 0 && selected.length >= _options.length) {
      return (
        <span style={{ float: "left", color: "#495057" }}>
          ALL
        </span>
      );
    } else if (selected.length > 1) {
      return (
        <div className={styleClass.valueContainer}>
          <div className={styleClass.multiValue}>
            <div className={styleClass.multiValueLabel}>
              <span data-toggle="tooltip" title={selected[0].label}>
                {selected[0].label}
              </span>
            </div>
            <div
              className={styleClass.multiValueClear}
              onClick={() => handleDeleteSelected(selected[0].value)}
            >
              <svg
                height="14"
                width="14"
                viewBox="0 0 20 20"
                className={styleClass.icon}
              >
                <path d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"></path>
              </svg>
            </div>
          </div>
          <div className={styleClass.allSelected}>
            <span id={`media-source-${filtered_by || "default"}`}>
              +{selected.length - 1}
            </span>
            <Tooltip
              placement="bottom"
              isOpen={tooltip}
              autohide={true}
              toggle={() => setTooltip(!tooltip)}
              target={`media-source-${filtered_by || "default"}`}
            >
              {selected.map((i, key) => (
                <div key={key} style={{ textAlign: "left" }}>
                  {key > 0 && i.label}
                </div>
              ))}
            </Tooltip>
          </div>
        </div>
      );
    } else if (selected.length === 0) {
      return (
        <span style={{ float: "left", color: "rgb(116, 120,141)" }}>
          {plug || "Select..."}
        </span>
      );
    }
  };

  const customItemRender = ({ checked, option, onClick, disabled }) => {
    if (option?.label === "SelectAll") {
      return (
        <ClearStyled
          className={`item-renderer ${disabled && "disabled"}`}
          style={{
            alignItems: "center",
          }}
        >
          <input
            type="checkbox"
            onChange={onClick}
            checked={checked}
            tabIndex={-2}
            disabled={disabled}
            style={{ display: "none" }}
          />
          <span>{checked ? "Clear all" : "Select all"}</span>
        </ClearStyled>
      );
    } else if (option?.label === "Filtered") {
      return (
        <ClearStyled
          className={`item-renderer ${disabled && "disabled"}`}
          style={{
            alignItems: "center",
          }}
        >
          <input
            type="checkbox"
            onChange={onClick}
            checked={checked}
            tabIndex={-1}
            disabled={disabled}
            style={{ display: "none" }}
          />
          <span>
            {checked ? "Clear all (Filtered)" : "Select all (Filtered)"}
          </span>
        </ClearStyled>
      );
    } else {
      return (
        <div
          className={`item-renderer ${disabled && "disabled"}`}
          style={{
            alignItems: "center",
          }}
        >
          <input
            className="form-check-input"
            type="checkbox"
            onChange={onClick}
            checked={checked}
            tabIndex={-1}
            disabled={disabled}
          />
          <LabelStyled>
            <span data-toggle="tooltip" title={option.label}>
              {option.label}
            </span>
          </LabelStyled>
        </div>
      );
    }
  };

  const filterOptions = (options, filter) => {
    if (!filter) {
      return options;
    }
    const re = new RegExp(filter, "i");
    return options.filter(({ label }) => label && label.match(re));
  };

  const ArrowRotate = arrow => {
    return (
      <svg
        style={{
          margin: '0 -2px 0 0'
        }}
        height="20"
        width="20"
        viewBox="0 0 20 20"
        aria-hidden="true"
        focusable="false"
        fill="#495057"
        transform={
          arrow.expanded === true ? "rotate(180,0,0)" : "rotate(0,0,0)"
        }
      >
        <path d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path>
      </svg>
    );
  };

  return (
    <SelectStyled
      options={data.map((item, index) => ({
        label: item.text,
        value: item.key,
        checked: item.checked,
        key: item.key,
        index,
      }))}
      value={selected}
      isLoading={isLoading}
      onChange={e => handleChangeCheckbox(e)}
      valueRenderer={customValueRenderer}
      ItemRenderer={customItemRender}
      ClearSelectedIcon={false}
      filterOptions={filterOptions}
      className={`${styleClass.MultiSelectClass} ${className} ${isDisabled ? 'is-disabled' : ''}`}
      shouldToggleOnHover={false}
      disableSearch={!search}
      disabled={isDisabled}
      style={{
        ...customWidth,
      }}
      hasSelectAll={hasSelectAll}
      ArrowRenderer={ArrowRotate}
      overrideStrings={{
        allItemsAreSelected: "All items are selected.",
        clearSearch: "Clear Search",
        noOptions: "No data available...",
        search: "Search...",
        selectAll: "SelectAll",
        selectAllFiltered: "Filtered",
        selectSomeItems: "Select...",
      }}
    />
  );
};

const ClearStyled = styled.div`
  left: -1px;
  position: absolute;
  //width: 240px;
  width: calc(100% + 2px);
  padding: 12px;
  bottom: -42px;
  background: #f8f8fb;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;

  &:hover {
    color: #556ee6;
  }
`;

const SelectStyled = styled(MultiSelect)`
  width: ${props => props.style?.width ? props.style.width : "240px"};

  &.is-disabled {
    .dropdown-container {
      background-color: #EFF2F7 !important;
      border: 1px solid #ced4da !important;
      border-radius: 4px;
      outline: 0px !important;
    }
  }

  .dropdown-container {
    height: 38px;
    border: 1px solid #ced4da;

    .dropdown-heading {
      height: 35px;

      .clear-selected-button {
        display: none;
      }

      svg {
        path {
          color: rgba(73, 80, 87, 1);
        }
      }
    }

    .dropdown-content {
      z-index: 999;

      .panel-content {
        .select-panel {
          .options {
            label {
              /* background-color: grey; */
              padding: 0;
            }

            li {
              label {
                padding: 7px 12px;
                background-color: #fff;
              }
            }
          }

          .select-item {
            background-color: #fff;
            margin-bottom: 0;
            padding: 0 12px;
            padding-bottom: 15px;
            user-select: none;
          }
        }
      }
    }

    &:focus-within {
      box-shadow: none !important;
      border-color: rgb(189, 195, 200) !important;
    }
  }
`;

const LabelStyled = styled.span`
  text-align: left;
  width: 180px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

DefaultMultipleSelect.propTypes = {
  options: PropTypes.any,
  onChange: PropTypes.func,
  clear: PropTypes.bool,
  search: PropTypes.bool,
  plug: PropTypes.string,
  filtered_params: PropTypes.any,
  filtered_by: PropTypes.any,
  className: PropTypes.string,
  isLoading: PropTypes.bool,
  defaultValue: PropTypes.array,
  hasSelectAll: PropTypes.bool,
  customWidth: PropTypes.object,
  isDisabled: PropTypes.bool,
};

export default DefaultMultipleSelect;
